// extracted by mini-css-extract-plugin
export default {"CoreBody":"HNSKe+c7X1CQ5g8hNiqjcQ==","CollapsedNavigation":"ZIvdmlJlTpplcrB0u9YL0g==","CoreContent":"Y9rXyzlbOJRBloE6iizMjA=="};